import Glide from '@glidejs/glide';

const animationDuration = 3000;

function initializeWordCarousel() {
  const components = document.querySelectorAll('.wp-block-ath-word-carousel');

  components.forEach((component) => {
    const glide = initializeGlide(component);

    component.addEventListener('mouseover', stopAnimation.bind(glide));

    component.addEventListener('mouseout', startAnimation.bind(glide));
  });
}

function initializeGlide(el) {
  const glide = el.querySelector('.glide');
  const numberOfSlides = glide.querySelector('ul').childElementCount;

  if (glide && numberOfSlides > 1)
    return new Glide(glide, {
      type: 'carousel',
      autoplay: 1,
      perView: numberOfSlides * 0.75,
      animationDuration,
      animationTimingFunc: 'linear',
      hoverpause: true,
      breakpoints: {
        1600: {
          perView: numberOfSlides * 0.5,
        },
        900: {
          perView: 2,
        },
        400: {
          perView: 1,
        },
      },
    }).mount();
}

function stopAnimation() {
  this.update({ autoplay: false, animationDuration: 0 });
}

function startAnimation() {
  this.update({ autoplay: 1, animationDuration });
}

export { initializeWordCarousel };
